import type { Entity } from '@backstage/catalog-model';
import type { EntityRefPresentationSnapshot } from '@backstage/plugin-catalog-react';
import {
  TECHDOCS_ANNOTATION,
  TECHDOCS_EXTERNAL_ANNOTATION,
} from '@backstage/plugin-techdocs-common';

export type OwnedEntityOption = {
  entityRef: string;
  label: string;
  caption: string;
};

export class OwnedEntityModel {
  readonly entityRef: string;
  readonly hasTechDocs: boolean;

  private constructor(
    entity: Entity,
    private readonly presentationSnapshot: EntityRefPresentationSnapshot,
  ) {
    this.entityRef = presentationSnapshot.entityRef;
    this.hasTechDocs = OwnedEntityModel.computeHasTechDocs(entity);
  }

  static fromEntity(
    entity: Entity,
    presentationSnapshot: EntityRefPresentationSnapshot,
  ): OwnedEntityModel {
    return new OwnedEntityModel(entity, presentationSnapshot);
  }

  shouldInclude(techDocsOnly: boolean): boolean {
    return !techDocsOnly || this.hasTechDocs;
  }

  toOption(): OwnedEntityOption {
    return {
      entityRef: this.entityRef,
      label: this.presentationSnapshot.primaryTitle,
      caption: this.entityRef,
    };
  }

  private static computeHasTechDocs(entity: Entity): boolean {
    const annotations = entity.metadata.annotations ?? {};

    return Boolean(annotations[TECHDOCS_ANNOTATION] || annotations[TECHDOCS_EXTERNAL_ANNOTATION]);
  }
}

export function sortOwnedEntityOptions(left: OwnedEntityOption, right: OwnedEntityOption): number {
  return left.label.localeCompare(right.label);
}
